// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 952 ? "book" : chunkId) + "." + {"51":"f849d42b","98":"aedce038","180":"4731f95b","266":"5f6b8613","591":"8833b6e3","844":"792d12b1","867":"9051c2b9","886":"73e1c831","899":"6fb68b71","920":"f7afa5cc","952":"729befc6","984":"5612c920"}[chunkId] + ".chunk.js";
};